module.exports = __webpack_public_path__ + "static/img/banner_marketing.cdf3264.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/home/imgs/head-banner/banner_marketing.jpg
// module id = 4ztu
// module chunks = 0